import React from 'react';

interface StepItem {
  title: string;
  detail: string;
}

interface HelpGuideProps {
  title: string;
  intro: string;
  steps: StepItem[];
  tone?: 'info' | 'success';
}

const toneClasses: Record<NonNullable<HelpGuideProps['tone']>, string> = {
  info: 'bg-blue-50 border-blue-200 text-blue-900',
  success: 'bg-green-50 border-green-200 text-green-900',
};

const HelpGuide: React.FC<HelpGuideProps> = ({ title, intro, steps, tone = 'info' }) => {
  return (
    <div className={`border rounded-lg p-4 sm:p-5 ${toneClasses[tone]}`}>
      <h3 className="text-sm sm:text-base font-semibold">{title}</h3>
      <p className="mt-1 text-xs sm:text-sm opacity-90">{intro}</p>
      <ol className="mt-3 space-y-2">
        {steps.map((step, index) => (
          <li key={`${step.title}-${index}`} className="flex items-start text-xs sm:text-sm">
            <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-white/80 text-gray-800 font-semibold mr-2 mt-0.5">
              {index + 1}
            </span>
            <span>
              <span className="font-medium">{step.title}:</span> {step.detail}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default HelpGuide;
